export class AccountManagementModel {
    userId: Number;    
    transactionId: number;
    paymentTransactionId: number;
    invoice: number;
    amount: any;
    firstname: any;
    lastname: any;
    paymentInfoId: number;    
    paymentInfoUrl: string;
};